import { useEffect, useRef, useState } from 'react';

/**
 * @param {MutableRefObject} target
 * @param {IntersectionObserverInit?} intersectionObserverOptions
 * @return {boolean}
 */
const useInViewport = (target, intersectionObserverOptions) => {
  const [, forceUpdate] = useState();
  const observer = useRef(null);
  const inViewportRef = useRef(false);
  const intersected = useRef(false);

  useEffect(() => {
    const node = target.current;

    if (node) {
      if (!observer.current) {
        observer.current = new IntersectionObserver((entries) => {
          const entry = entries[0] || {};
          const { isIntersecting, intersectionRatio } = entry;
          const isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;

          if (!intersected.current && isInViewport) {
            intersected.current = true;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
          } else if (intersected.current && !isInViewport) {
            intersected.current = false;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
          }
        }, intersectionObserverOptions);
      }

      if (observer.current) {
        observer.current.observe(node);
      }
    }

    return () => {
      if (observer.current) {
        if (node) {
          observer.current.unobserve(node);
        }

        observer.current.disconnect();
        observer.current = null;
      }
    };
  }, [target, intersectionObserverOptions]);

  return inViewportRef.current;
};

export default useInViewport;
